"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4455],{

/***/ 84455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84099);
/* harmony import */ var react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54176);
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52738);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77058);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9465);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var ExternalWeb = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return __webpack_require__.e(/* import() */ 6833).then(__webpack_require__.bind(__webpack_require__, 66833));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(66833)];
    }
  }
});

var MapContainer = function MapContainer(props) {
  var _useTranslation = (0,react_i18next__WEBPACK_IMPORTED_MODULE_8__/* .useTranslation */ .$)(),
      t = _useTranslation.t;

  var location = props.location,
      address = props.address,
      accomodationUrl = props.accomodationUrl,
      transportUrl = props.transportUrl,
      mapLink = props.mapLink,
      isMobileVersion = props.isMobileVersion;

  var region = _objectSpread(_objectSpread({}, location), {}, {
    latitudeDelta: 0.0922,
    longitudeDelta: 0.0421
  });

  var navigation = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();

  var onOpenExternalLink = function onOpenExternalLink(url) {
    var win = window.open(url, "_blank");
    win.focus();
  };

  var onButtonAction = function onButtonAction(actionType) {
    if (actionType == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.actionType.ACTION_GOOGLE_MAP */ .gT.actionType.ACTION_GOOGLE_MAP) {
      onOpenExternalLink(mapLink);
      return;
    }

    var tabIndex = 0;

    if (actionType == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.actionType.ACTION_MAP */ .gT.actionType.ACTION_MAP) {
      tabIndex = 0;
    } else if (actionType == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.actionType.ACTION_ACCOMODATION */ .gT.actionType.ACTION_ACCOMODATION) {
      tabIndex = 1;
    } else if (actionType == _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.actionType.ACTION_TRANSPORT */ .gT.actionType.ACTION_TRANSPORT) {
      //tabIndex = 2;
      onOpenExternalLink(transportUrl);
      return;
    }

    navigation.push({
      pathname: "/map/MapScreen",
      query: {
        accomodationUrl: accomodationUrl,
        transportUrl: transportUrl,
        region: region,
        address: address,
        tabIndex: tabIndex
      }
    }); // navigation.navigate("MapScreen", {
    //   region: region,
    //   address: address,
    //   tabIndex,
    //   accomodationUrl: accomodationUrl,
    //   transportUrl: transportUrl,
    // });
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
    style: [styles.container, props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
      style: [styles.buttonContainer, isMobileVersion ? {
        padding: 14
      } : {}],
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_3__/* .IconizedButton */ .YJ, {
        filled: true,
        isHeading: true,
        buttonTitle: t("key_button_google_map"),
        style: {
          flex: 1,
          height: isMobileVersion ? 24 : 40
        },
        fontSize: isMobileVersion ? 10 : 16,
        onPress: function onPress() {
          onButtonAction(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.actionType.ACTION_GOOGLE_MAP */ .gT.actionType.ACTION_GOOGLE_MAP);
        },
        filledTextColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("btn-text-black"),
        isMobileVersion: isMobileVersion
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_atoms__WEBPACK_IMPORTED_MODULE_3__/* .IconizedButton */ .YJ, {
        filled: true,
        isHeading: true,
        buttonTitle: t("key_button_transport"),
        style: {
          flex: 1,
          height: isMobileVersion ? 24 : 40,
          marginLeft: isMobileVersion ? 10 : 30
        },
        fontSize: isMobileVersion ? 10 : 16 // disabled={true}
        ,
        onPress: function onPress() {
          onButtonAction(_config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.actionType.ACTION_TRANSPORT */ .gT.actionType.ACTION_TRANSPORT);
        },
        filledTextColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("btn-text-black"),
        isMobileVersion: isMobileVersion
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(ExternalWeb, {
      url: accomodationUrl,
      isMobileVersion: isMobileVersion
    })]
  });
};

var styles = react_native_web_dist_cjs_exports_StyleSheet__WEBPACK_IMPORTED_MODULE_10___default().create({
  container: {
    backgroundColor: (0,_helpers_formatHelpers__WEBPACK_IMPORTED_MODULE_5__/* .getClass */ .ll)("bg-gray1"),
    alignSelf: "stretch",
    position: "relative",
    borderRadius: 20
  },
  buttonContainer: {
    paddingVertical: 20,
    paddingHorizontal: 30,
    width: "100%",
    flexDirection: "row",
    top: 0,
    left: 0
  },
  expandMapButton: {
    width: 45,
    height: 45,
    position: "absolute",
    right: 20,
    bottom: 20,
    backgroundColor: "white",
    borderRadius: 25,
    alignItems: "center",
    justifyContent: "center"
  },
  expandIcon: {
    width: 21,
    height: 21
  }
});
/* harmony default export */ __webpack_exports__["default"] = (MapContainer);

/***/ })

}]);